<div class="full-upload-zone">
  <div class="upload-zone">
    <div class="limits">
      {{ 'ITSM.ADDACTION.FILES.LIMITS' | translate }}
    </div>
    <input type="file"
      id="fileToUploadId"
      name="fileToUpload"
      [attr.value]="value"
      class="visually-hidden"
      (change)="fileChangeEvent($event)" />
      <label for="fileToUploadId">
        <div class="drop-file"
          [ngClass]="dragOver ? 'drag-over' : ''"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          <div id="drop-zone"
            class="text-wrapper">
            <div class="centered">
              {{ prompt }}
              <i class="fal fa-mouse-pointer"
                aria-hidden="true">
              </i>
            </div>
          </div>
        </div>
      </label>
    </div>
    @if ((nbFiles | async); as nbFiles) {
      <div class="upload-infos">
        @for (file of (files | async); track file) {
          <div
            class="file">
            <aa-upload-file-displayer [file]="file">
            </aa-upload-file-displayer>
          </div>
        }
      </div>
    }
  </div>
